import type { Dispatch, SetStateAction } from 'react'
import React, { useEffect } from 'react'

import type { ScrollRef } from 'components/LayoutPage/LayoutScroll/LayoutScroll'
import type { IEmptyProps } from 'components/uiKit/Empty'
import Empty from 'components/uiKit/Empty'
import InfiniteLoadGrid from 'components/uiKit/InfiniteLoadGrid'
import { t } from 'services/Translation'
import type { FinderItem } from 'store/models'

import type { Paths } from '../types'
import GridItem from './GridItem'
import GridItemModal from './GridItemModal'

interface IFinderCardProps {
  data: FinderItem[]
  onChangeSelection: Dispatch<SetStateAction<FinderItem[]>>
  onClickItem: (item: FinderItem) => void
  total: number
  selectedItems: FinderItem[]
  loading: boolean
  empty?: IEmptyProps
  clearQuery: () => void
  paths: Paths
  fetchMore?: () => Promise<unknown>
  isModal?: boolean
  checkbox?: boolean
}

const FinderCard = React.forwardRef<ScrollRef, IFinderCardProps>(
  (
    {
      data,
      onChangeSelection,
      onClickItem,
      total,
      selectedItems,
      loading,
      clearQuery,
      paths,
      fetchMore,
      isModal,
      checkbox,
    },
    ref,
  ) => {
    useEffect(() => {
      onChangeSelection([])
    }, [data, onChangeSelection])

    if (!loading && data.length === 0) {
      return <Empty icon='folder' text={t('common.nothingFound')} grow />
    }

    return (
      <InfiniteLoadGrid
        chunkLoading={loading}
        fetchMore={fetchMore}
        grid={{ width: '308px' }}
        hasMore={total > data.length}
        loading={loading}
        name='filePicker'
        padding='5px 0 20px'
        ref={ref}
      >
        {data.map((item) =>
          isModal ? (
            <GridItemModal
              checkbox={checkbox}
              clearQuery={clearQuery}
              item={item}
              key={item.id}
              onChangeSelection={onChangeSelection}
              onClick={onClickItem}
              selectedItems={selectedItems}
            />
          ) : (
            <GridItem
              clearQuery={clearQuery}
              item={item}
              key={item.id}
              onChangeSelection={onChangeSelection}
              paths={paths}
              selectedItems={selectedItems}
            />
          ),
        )}
      </InfiniteLoadGrid>
    )
  },
)

FinderCard.displayName = 'FinderCard'

export default FinderCard
